import { type UseQueryResult, useQuery } from 'react-query';
import { PlanApprovalService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetPlanManagementApprovalStatusList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const getPlanManagementApprovalStatusList = useQuery(
    ['getCustomerUserCustomerUserStatusList'],
    async () => {
      return await handleRequest(PlanApprovalService.getApiAwardApiAppPlanApprovalPlanStatus());
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.statusName ?? '',
            value: item.id ?? '',
          };
        });

        const sortOptions = options?.concat({ label: 'All', value: 5 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return getPlanManagementApprovalStatusList;
};

export default useGetPlanManagementApprovalStatusList;
